import React from 'react';
import PropTypes from 'prop-types';

import { getCourseColor } from '../../../utils/course-utils';

const getCirclesOpacity = level => [1, level > 1 ? 1 : 0.3, level > 2 ? 1 : 0.3];

const getColors = (isColorful, type) => {
  if (!isColorful) {
    return ['white', 'white'];
  }

  return [getCourseColor(type), '#131925'];
};

const getCirclesColors = (level, type, isColorful) => {
  const [activeColor, baseColor] = getColors(isColorful, type);

  return [activeColor, level > 1 ? activeColor : baseColor, level > 2 ? activeColor : baseColor];
};

const CourseLevelIcon = props => {
  const [o1, o2, o3] = getCirclesOpacity(props.level || 1);

  // TODO it can be done with classes
  const [c1, c2, c3] = getCirclesColors(props.level || 1, props.type || 1, props.isColorful || false);

  return (
    <svg width="32" height="8" viewBox="0 0 32 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="4" cy="4" r="4" fill={c1} fillOpacity={o1} />
      <circle cx="16" cy="4" r="4" fill={c2} fillOpacity={o2} />
      <circle cx="28" cy="4" r="4" fill={c3} fillOpacity={o3} />
    </svg>
  );
};

CourseLevelIcon.propTypes = {
  level: PropTypes.number.isRequired,
  type: PropTypes.number,
  isColorful: PropTypes.bool,
};

export default CourseLevelIcon;
